import script from "./AdventureChatInputField.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatInputField.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatInputField.vue?vue&type=style&index=0&id=38b34a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b34a28"]])

export default __exports__